import { bold, columnCenter, h5, subTitle1 } from "../../../resources/styles";
import { makeStyle } from "../../../utils";

const styles = {};


styles['image'] = makeStyle({
    position: 'absolute', top: 0,
    objectFit: 'cover',
    objectPosition: '0% 33%',
    height: '100%', width: '100%',
    backgroundColor: '#d0d9e3',
    filter: 'blur(1.5px)',
});


styles['right_card_override'] = makeStyle({ backgroundColor: '#0000005e', color: 'white', width: '100%', maxWidth: 500 });


styles['image_heading'] = makeStyle([h5, { padding: 16, fontSize: 28, textAlign: 'center' }]);

styles['image_divider'] = makeStyle({ width: 100, height: 3, borderRadius: 2, backgroundColor: 'white' });

styles['image_content'] = makeStyle([subTitle1, bold, { padding: 16, textAlign: 'center', maxWidth: 500 }]);


styles['section_heading'] = makeStyle([h5, { padding: '24px 24px 8px', textAlign: 'center' }]);

styles['case_studies'] = makeStyle([columnCenter, { padding: '24px 0' }]);

styles['case_study'] = makeStyle({ maxWidth: 960, padding: '24px 0', margin: '0 auto !important' });

styles['case_study_reverse'] = makeStyle({ maxWidth: 960, padding: '24px 0', margin: '0 auto !important', flexDirection: 'row-reverse' });


styles['videos_container'] = makeStyle({ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', padding: 24 });



export default styles;